import { render, staticRenderFns } from "./AuthorizationsIndexPage.vue?vue&type=template&id=5601545c&"
import script from "./AuthorizationsIndexPage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsIndexPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsIndexPage.vue?vue&type=style&index=0&language=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports